import { useCurrency } from '../contexts/CurrencyContext';

function useSteps() {
  const { config } = useCurrency();
  return [
    {
      number: 1,
      title: 'Answer Privately',
      description:
        "Go through 150+ fun questions. It\u2019s 100% anonymous: no email or account needed.",
    },
    {
      number: 2,
      title: 'Share the Link',
      description:
        'Send your partner a private link. They answer on their device. Zero peeking allowed!',
    },
    {
      number: 3,
      title: 'Find Your Matches',
      description:
        `We reveal only what you both want. Preview for free, or reveal everything for ${config.label}.`,
    },
  ];
}

export default function HowItWorks() {
  const STEPS = useSteps();
  return (
    <section className="mb-24">
      {/* Steps */}
      <div className="relative">
        {/* Desktop connecting line (horizontal) */}
        <div className="hidden md:block absolute top-7 left-[10%] right-[10%] h-px bg-white/10 z-0" />

        <div className="flex flex-col md:flex-row md:justify-between items-start gap-10 md:gap-6">
          {STEPS.map((step, i) => (
            <div
              key={step.number}
              className="relative flex md:flex-col items-start md:items-center gap-5 md:gap-4 w-full md:w-1/3"
            >
              {/* Mobile connecting line segment (between steps only) */}
              {i < STEPS.length - 1 && (
                <div className="md:hidden absolute left-6 top-12 bottom-0 w-px bg-white/10 -mb-10" />
              )}

              {/* Glass number circle */}
              <div
                className="relative z-10 w-12 h-12 md:w-14 md:h-14 flex-shrink-0 rounded-full border border-white/20 bg-white/5 backdrop-blur-md flex items-center justify-center font-bold text-lg text-white"
                style={{ boxShadow: '0 8px 32px 0 rgba(0,0,0,0.3)' }}
              >
                {step.number}
              </div>

              {/* Text */}
              <div className="md:text-center">
                <h3 className="text-sm font-black uppercase tracking-widest mb-1 text-white">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-[13px] leading-relaxed max-w-[240px]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Privacy note */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 text-white/20">
            <span className="material-symbols-outlined text-sm">lock</span>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em]">
              <span className="hidden sm:inline">Encrypted &bull; </span>Data auto-deletes after 30 days
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
